export default {
  app: {
    title: "React template",
  },
  refresh: {
    title: "Är du aktiv?",
    cta: "Du registrerades som inaktiv, vänligen bekräfta att du är aktiv inom en minut, annars kommer du att loggas ut.",
  },
  common: {
    language: "Språk",
    english: "Engelska",
    serbian: "Serbiska",
    dataGridExample: "Exempel på Data Grid",
    close: "Stäng",
    trademark: "TM",
    search: "Sök",
    error: "Fel",
    continue: "Fortsätt",
    labelUsername: "Användarnamn",
    labelEmail: "E-post",
    labelPassword: "Lösenord",
    next: "Nästa",
    nextPage: "Nästa sida",
    previousPage: "Föregående sida",
    back: "Tillbaka",
    goBack: "Gå tillbaka",
    ok: "OK",
    done: "Klart",
    confirm: "Bekräfta",
    printDownload: "Skriv ut/Ladda ner",
    cancel: "Avbryt",
    remove: "Ta bort",
    invite: "Bjud in",
    save: "Spara",
    complete: "Slutför",
    download: "Ladda ner",
    yes: "Ja",
    no: "Nej",
    to: "till",
    select: "Välj...",
    none: "Inga",
    date: {
      range: "{{start}} till {{end}}",
    },
    logout: "Logga ut",
    seeMore: "Se mer",
    contactUs: "Kontakta oss",
    tryForFree: "Prova gratis",
    supportLink: "im.support@tremium.net",
    martketingLink: "marketing@tremium.net",
    phoneNumber: "+38160 366 02 71",
  },

  notifications: {
    title: "Notifikationer",
  },
   pages: {
    home: "Hem",
    login: "Logga in",
    register: "Registrera",
    forgotPassword: "Glömt lösenord",
    error: "Fel",
    notFound: "Hittades inte",
    profile: "Profil",
    settings: "Inställningar",
    dashboard: "Instrumentpanel",
    about: "Om oss",
    careers: "Karriärer",
    contact: "Kontakt",
  },
  register: {
    registerTitle: "Registrera",
    usernameRequired: "Användarnamn krävs.",
    emailFormat: "Ogiltigt e-postformat.",
    emailRequired: "E-postadress eller användarnamn krävs.",
    passwordLength: "Ditt lösenord måste innehålla mellan 8 och 50 tecken.",
    passwordRequired: "Lösenord krävs.",
  },
  login: {
    welcome: "React-mall",
    dontHaveAccount: "Har du inget konto? ",
    emailFormat: "Ogiltigt e-postformat.",
    emailRequired: "E-postadress eller användarnamn krävs.",
    noUsers: "Det finns inga användare med den e-postadressen.",
    passwordStrength: "Ditt lösenord är {{strength}}.",
    passwordLength: "Ditt lösenord måste innehålla mellan 8 och 50 tecken.",
    signUpRecommendation: "Registrera dig",
    email: "Ange din e-postadress eller ditt användarnamn för att logga in:",
    logInTitle: "Logga in",
    logIn: "Logga in",
    signUp: "Registrera",
    usernameRequired: "Användarnamn krävs.",
    passwordRequired: "Lösenord krävs.",
    forgotYourPassword: "Glömt ditt lösenord?",
    forgotPasswordEmail: "E-post",
    useDifferentEmail: "Använd en annan e-postadress eller användarnamn",
  },
  password: {
    weak: "svagt",
    average: "medel",
    good: "bra",
    strong: "starkt",
  },
  forgotPassword: {
    title: "Glömt lösenord",
    label: "Skicka e-post",
    emailRequired: "E-post krävs.",
    emailFormat: "Ogiltigt e-postformat.",
    forgotPassword: {
      title: "Glömt lösenord",
      subtitle:
        "Svara på säkerhetsfrågan för att få tillgång till ditt konto:",
      label: "Återställ lösenord",
    },
  },
  notFound: {
    text: "Tyvärr kunde vi inte hitta sidan du letade efter.",
    goBack: "Gå tillbaka till startsidan",
  },
  errorPage: {
    text: "Tyvärr uppstod ett internt serverfel. Var vänlig och försök igen senare.",
    goBack: "Gå tillbaka till startsidan",
    logout: "Logga ut",
  },
  apiErrors: {
    ClientIpAddressIsNullOrEmpty: "Klientens IP-adress är tom eller saknas",
    UsernameDoesNotExist: "Användarnamnet finns inte",
    WrongCredentials: "Felaktiga inloggningsuppgifter",
    SomethingWentWrong: "Något gick fel",
    WrongPasswordAccountIsLocked: "Felaktiga uppgifter, kontot är låst",
    AccountIsLocked: "Kontot är låst",
  },
  date: {
    timespan: {
      yearsAgo: "Pre {{years}} godine",
      monthsAgo: "Pre {{months}} meseca",
      daysAgo: "Pre {{days}} dana",
      hoursAgo: "Pre {{hours}} sata",
      minutesAgo: "Pre {{minutes}} minuta",
      secondsAgo: "Pre {{seconds}} sekunde",
      now: "Upravo sada",
    },
  },
  dashboard: {
    charts: {
      lineChart: "Linijski grafikon",
      pieChart: "Kružni grafikon",
      barChart: "Dijagram",
      radarChart: "Radarski grafikon",
    },
  },
  profile: {
    image: "Slika profila",
    chooseImage: "Izaberi sliku za profil",
    form: {
      step1: "Lični podaci",
      step2: "Adresa",
      step3: "Posao",
    },
    labels: {
      firstName: "Ime",
      lastName: "Prezime",
      gender: "Pol",
      city: "Grad",
      street: "Ulica",
      postalCode: "Poštanski broj",
      companyName: "Ime firme",
      companyAddress: "Adresa firme",
      yearsInCompany: "Broj godina u firmi",
    },
  },
  footer: {
    text: "Inspect Master <3> Copyright © 2023 </3> <1></1> <2>Tremium Software.</2> Alla rättigheter förbehållna.",
    navItems: {
      item1: "Hem",
      item2: "Fördelar",
      item3: "Demo",
      item4: "Hjälp",
      item5: "Integritetspolicy",
      item6: "Kontakt",
    },
  },
  header: {
    navItems: {
      item1: "Hem",
      item2: "Fördelar",
      item3: "Hjälp",
      item4: "Kontakt",
      item5: "Logga in",
    },
  },
  sectionHero: {
    title: "Processverifiering. Automatisering av kontroll. Tidsbesparing.",
    text: "Inspect Master utgör en lösning för alla Era behov inom området kontroll av säkerhetsvillkor på arbetsplatsen. Vår plattform erbjuder automatisering, standardisering och systematisk datahantering och löser viktiga utmaningar som traditionella kontrollprocesser står inför.",
    buttonLabel: "Kontakta oss",
  },
  sectionWhy: {
    title: "Varför just Inspect Master?",
    cards: {
      card1: {
        title: "Automatisering",
        text: "Kontrollprocessen är automatiserad från själva startpunkten till framställning av granskingsrapporten som slutprodukt. Automatisering av processen sparar tid och ger effektivitet i arbetet.",
      },
      card2: {
        title: "Anpassningsbarhet",
        text: "Genom att använda personaliserade mallar möjliggör vår plattform anpassning av kontrollprocessen till vilken typ av undersökning som helst.",
      },
      card3: {
        title: "Felfritt",
        text: "Genom att förbereda mallar som noggrant leder genom kontrollprocessen minskar ni möjligheten för fel och ökar effektiviteten i arbetet.",
      },
      card4: {
        title: "Tidsbesparing",
        text: "Glöm tidskrävande procedurer och långdraget skapande av rapporter. Inspect Master genererar automatiskt granskningsrapporter, vilket sparar tid vid inmatning och bearbetning av data.",
      },
      card5: {
        title: "Administration och struktur",
        text: "Vår applikation erbjuder enkel hantering av alla parametrar som behövs för att skapa granskingsrapporter. Granskingsrapporten är applikationens huvuddokument, och vårt system möjliggör sökning och filtrering av data enligt Era behov.",
      },
    },
  },
  sectionInfo: {
    text: "Manuell datahantering och brist på dokumentation tillhör det förflutna med vår mjukvarulösning. Inspect Master möjliggör snabb och effektiv datainmatning via dator, telefon och surfplatta vilket underlättar arbetet i fält. <br /><br /> I syfte att påskynda och standardisera kontrollprocessen genererar vår applikation granskninsrapporter skapade enligt fördefinierade mallar och i enlighet med gällande föreskrifter.",
  },
  sectionMakePossible: {
    title: "Vad möjliggör <br /> Inspect Master?",
    items: [
      "Möjlighet att mata in testresultat genom text, bild eller tabell",
      "Framställning av granskninsrapporter efter inmatning av testdata",
      "Export av rapporter i PDF-format",
      "Automatisk sändning av granskninsrapporter via e-post",
      "Möjlighet att kopiera befintliga utlåtanden",
      "Användning av enheter för snabb datainmatning",
      "Arkivering av granskingsrapporter och förvaring av säkerhetskopior i molnet",
      "Möjlighet att skapa mallar som används för automatisering av kontroll av processer och arbetsutrustning enligt krav och standarder specifika för en viss industri",
      "Sökning och snabb åtkomst till alla rapporter",
    ],
  },
  sectionTrial: {
    title: "Registrera Er första <br /> månaden gratis!",
    text1: "Den kostnadsfria versionen inkluderar:",
    text2:
      "Efter utgången av testperioden på en månad, kontakta oss för prisofferter och förlängning av licensen.",
    trialList: [
      "Obegränsat antal användare och granskingsrapporter",
      "Sändning av granskninsrapporter på e-post när undersökningsformuläretet stängs",
      "Utskriftsinställningar och tillgång till mallar",
      "Kopiering av undersökningsobjekt och granskninsrapporter.",
      "Lagring av granskninsrapporter i molnet när undersökningsformuläret stängs",
      "Dokumenthanteringssida",
    ],
  },
  sectionFAQ: {
    title: "Vanliga frågor",
    note: "Har du fortfarande en fråga?",
    questions: {
      question1: {
        question: "Hur registrerar man sig på plattformen?",
        answer:
          "Med bara ett samtal eller e-post! Det första kontot för ditt team på plattformen skapas av Inspect Master supportteam, vilket tilldelar dig rollen som administratör. Därefter kan administratören lägga till övriga teammedlemmar och tilldela dem olika roller på plattformen.",
      },
      question2: {
        question: "Vilka är de viktigaste delarna av Inspect Master?",
        answer:
          "Undersökningsämnen som består av flera sektioner är den grundläggande delen av applikationen. Därför skapas de innan själva undersökningen för att underlätta vidare kontroller. Förutom undersökningsämnena är granskningsrapporterna det slutgiltiga dokumentet som erhålls efter fältundersökningen. De genereras genom att fylla i resultaten från undersökningen på plats.",
      },
      question3: {
        question: "Hur definieras <i>undersökningsparametrarna?</i>",
        answer:
          "Inom plattformen behöver man definiera nödvändiga parametrar: arbetsområden som företaget är verksamt inom (typer av undersökningar), de regler och standarder som gäller för undersökningarna, de instrument som används för undersökningarna samt de klienter för vilka undersökningen utförs.",
      },
      question4: {
        question: "Hur definieras <i>undersökningsämnen?</i>",
        answer:
          "Undersökningsämnen kan fördefinieras på två sätt: genom import från ett gemensamt bibliotek eller genom att skapa dem självständigt. Vid självständig skapande av ett ämne bör man definiera typ av granskning, de instrument som används för undersökningen samt de regler och standarder som gäller. Därefter förbereds de frågor som behöver besvaras vid ifyllandet av granskningsrapporten. Det är också möjligt att fördefiniera slutsatser och svar på frågorna för att optimera tiden som krävs för inmatning på plats.",
      },
      question5: {
        question: "Hur registreras undersökningsresultat?",
        answer:
          "Svar på de förberedda frågorna i granskningsrapporten registreras som text, genom att fylla i en tabell, som bild eller genom att välja ett av de tillgängliga alternativen. I slutet formuleras en slutsats - antingen positiv eller negativ. En granskningsrapport kan innehålla flera undersökningsämnen.",
      },
      question6: {
        question: "Vilka är de ytterligare funktionerna?",
        answer:
          "Förutom de primära funktionerna har Inspect Master ytterligare funktioner som automatisk sparning av granskningsrapporter och mallar. Granskningsrapporter kan sparas i molnet eller skickas direkt till klienter via e-post. En stor fördel är också mallbaserade, fördefinierade svar på de vanligaste frågorna som kan läggas till automatiskt i granskningsrapporten, samt redan definierade undersökningsmallar.",
      },
    },
  },
  sectionAbout: {
    title: "Om oss",
    text: "<1>För några år sedan kontaktade vår nuvarande långvariga partner oss med ett problem i deras dagliga verksamhet. De behövde ett verktyg som kunde hjälpa dem att optimera processer, utföra undersökningar mer effektivt och generera professionella granskningsrapporter. Så föddes Inspect Master – en lösning som vi skapade som svar på vardagliga utmaningar och problem i den verkliga verksamheten inom kontroll av arbetsmiljösäkerhet. </1> <1>Inspect Master är en produkt utvecklad av IT-programvaruföretaget Tremium Software, och ett team arbetar dagligen med att noggrant implementera de senaste förändringarna och funktionerna. Vi strävar efter att vara konsekventa med våra partners behov, samtidigt som vi inför nya uppdateringar för att utöka användningen av vår plattform. </1>",
  },
  sectionContact: {
    title: "Kontakta oss",
    text: "Inspect Master ger dig möjlighet att välja de funktioner som bäst passar dina behov. För information om prisalternativ samt gratis provregistrering, kontakta oss via e-post på <1>im.support@tremium.net</1> eller genom att ringa <2>+38160 366 02 71</2>.",
  },
  privacyPolicy: {
  title: "Integritetspolicy",
  lastUpdate: "Senast uppdaterad: 11 mars 2025.",
  text: "Denna integritetspolicy beskriver de villkor under vilka Inspect Master samlar in, använder och behandlar dina personuppgifter när du besöker eller använder någon av våra webbplatser eller tjänster. Policyn förklarar bland annat vilka typer av personuppgifter vi samlar in, syftet med behandlingen samt dina rättigheter och skyldigheter i samband med dessa uppgifter.",
  definition: {
    title: "Definitioner",
    definitions: [
      "<strong>Konto</strong> avser ett unikt användarkonto som skapats för att få tillgång till vår tjänst eller delar av den.",
      "<strong>Produkten</strong> (i detta dokument kallad ”Produkten”, ”Vi”, ”Oss” eller ”Vår”) hänvisar till Inspect Master.",
      "<strong>Cookies</strong> är små filer som en webbplats placerar på din dator, mobiltelefon eller annan enhet och som innehåller information om din surfaktivitet på webbplatsen.",
      "<strong>Länder</strong> avser: Serbien, Nordmakedonien, Montenegro, Schweiz och EU-länderna.",
      "<strong>Personuppgifter</strong> är information som hänför sig till en identifierad fysisk person.",
      "<strong>Användningsdata</strong> är data som samlas in automatiskt vid användning av tjänsten eller genom dess infrastruktur (t.ex. besökstid på en viss sida).",
      "<strong>Webbplats</strong> avser Inspect Master, tillgänglig på domänen <a href='https://www.inspectmaster.net'>www.inspectmaster.net</a>."
    ]
  },
  personalData: {
    title: "Insamling och användning av dina personuppgifter",
    subtitle: "Typer av uppgifter vi samlar in",
    personalDataTitle: "Personuppgifter",
    personalDataDescription: "När du använder vår tjänst kan vi be dig att lämna viss information som kan användas för att identifiera eller kontakta dig. Dessa uppgifter kan omfatta, men är inte begränsade till:",
    personalDataList: [
      "<strong>E-postadress</strong>",
      "<strong>Förnamn</strong>",
      "<strong>Efternamn</strong>",
      "<strong>Telefonnummer</strong>",
      "<strong>Företagsnamn</strong>",
      "<strong>Momsregistreringsnummer</strong>",
      "<strong>Företagsadress</strong>",
      "<strong>Organisationsnummer</strong>",
      "<strong>Titel</strong>",
      "<strong>Licensnummer</strong>",
      "<strong>Bild av signatur</strong>",
    ],
    usageData: "Användningsdata",
    usageDataDescription: [
      "Användningsdata samlas in automatiskt när du använder vår tjänst. Dessa uppgifter kan inkludera information som din enhets IP-adress, webbläsartyp och version, sidor du besöker, datum och tid för besöket, tid spenderad på sidorna, unika enhetsidentifierare och annan diagnostisk data.",
      "Om du använder tjänsten via en mobil enhet kan vi automatiskt samla in ytterligare information, inklusive men inte begränsat till typ av mobil enhet, unikt enhets-ID, IP-adress, operativsystem, mobil webbläsartyp och annan diagnostisk data.",
    ],
  },
  cookies: {
    title: "Spårningstekniker och cookies",
    text: "Vi använder cookies och liknande spårningstekniker för att följa aktiviteten i vår tjänst och lagra viss information.",
    browserCookiesSubtitle: "Webbläsarcookies",
    browserCookiesText: "En cookie är en liten fil som placeras på din enhet. Du kan ställa in din webbläsare att neka alla cookies eller att meddela dig när en cookie skickas. Om du inte accepterar cookies kanske du inte kan använda vissa delar av våra tjänster. Om du inte har ställt in din webbläsare att neka cookies kan våra tjänster använda cookies.",
    subtitle: "Typer av cookies vi använder",
    sessionCookiesTitle: "Nödvändiga cookies",
    sessionCookiesList: [
      "<strong>Typ:</strong> Sessionscookies",
      "<strong>Syfte:</strong> Dessa cookies är nödvändiga för att tillhandahålla de tjänster som är tillgängliga via webbplatsen och möjliggöra dess funktioner, inklusive användarautentisering och förebyggande av missbruk av konton.",
    ],
    persistentCookiesTitle: "Cookies för samtycke till cookiepolicy",
    persistentCookiesList: [
      "<strong>Typ:</strong> Beständiga cookies",
      "<strong>Syfte:</strong> Dessa cookies registrerar om du har accepterat användningen av cookies på vår webbplats.",
    ],
    functionalityCookiesTitle: "Funktionscookies",
    functionalityCookiesList: [
      "<strong>Typ:</strong> Beständiga cookies",
      "<strong>Syfte:</strong> Dessa cookies gör att vi kan komma ihåg dina val (t.ex. inloggningsuppgifter eller språkpreferenser) för att ge dig en personlig användarupplevelse.",
    ],
  },
  usePersonalData: {
    title: "Användning av dina personuppgifter",
    text: "Dina personuppgifter kan användas för följande ändamål:",
    list: [
      "<strong>För att tillhandahålla och underhålla vår tjänst</strong>, inklusive övervakning av dess användning.",
      "<strong>För att hantera ditt konto</strong> och ge dig tillgång till funktioner som endast är tillgängliga för registrerade användare.",
      "<strong>För att kommunicera med dig</strong> via e-post, telefonsamtal, SMS eller appaviseringar angående uppdateringar, säkerhetsmeddelanden och liknande information.",
      "<strong>För att informera dig om nyheter, kampanjer och liknande erbjudanden</strong>, såvida du inte väljer att avstå från dem.",
      "<strong>För att behandla och hantera dina förfrågningar</strong> som du skickar till oss.",
      "<strong>För dataanalys</strong>, trendövervakning, förbättring av våra tjänster och utvärdering av marknadsföringskampanjer.",
    ],
    share: "Vi kan dela dina personuppgifter i följande situationer:",
    shareList: [
      "<strong>Med ditt samtycke</strong> – när du har godkänt delning av data för specifika ändamål.",
    ]
  },
  retentionPersonalData: {
    title: "Lagring av dina personuppgifter",
    list: [
      "Företaget kommer att behålla och använda dina personuppgifter i den utsträckning som krävs för att uppfylla våra rättsliga skyldigheter (till exempel om vi måste behålla dina uppgifter för att följa gällande lagar), lösa tvister och upprätthålla våra juridiska avtal och policyer.",
      "Företaget kommer också att behålla användningsdata för interna analyser. Användningsdata lagras vanligtvis under en kortare period, utom när dessa data används för att stärka säkerheten eller förbättra våra tjänsters funktionalitet, eller när vi är lagligt skyldiga att behålla dem längre.",
    ]
  },
  transferPersonalData: {
    title: "Överföring av dina personuppgifter",
    list: [
      "Genom att använda vår tjänst och tillhandahålla dina uppgifter samtycker du till att de eventuellt kan överföras till andra länder. Vi vidtar alla rimliga åtgärder för att säkerställa en säker hantering av dina uppgifter i enlighet med denna integritetspolicy.",
      "Inom ramen för tjänsten kan du uppdatera eller ändra dina uppgifter via kontoinställningar eller genom att kontakta vår support.",
    ]
  },
  disclosurePersonalData: {
    title: "Utlämnande av dina personuppgifter",
    textTitle: "Juridiska krav",
    text: "Under vissa omständigheter kan företaget vara skyldigt att lämna ut dina personuppgifter om det krävs enligt lag eller som svar på giltiga begäranden från offentliga myndigheter (t.ex. domstolar eller myndigheter).",
    otherLegalrequirements: "Rättsliga krav",
    otherLegalrequirementsText: "I vissa situationer kan vi vara skyldiga att lämna ut dina uppgifter enligt lag eller på begäran av statliga organ, inklusive:",
    otherLegalrequirementsList: [
      "Följa rättsliga skyldigheter",
      "Skydda våra rättigheter och tillgångar",
      "Utreda potentiella olagliga aktiviteter",
      "Skydda användarnas och allmänhetens säkerhet",
      "Försvara oss mot rättsliga anspråk",
    ],
  },
  securityPersonalData: {
    title: "Säkerhet för dina uppgifter",
    text: "Din integritet är viktig för oss, men kom ihåg att ingen metod för dataöverföring över internet eller elektronisk lagring är 100 % säker. Vi tillämpar kommersiellt rimliga skyddsåtgärder, men vi kan inte garantera absolut säkerhet för dina uppgifter.",
  },
  changesPrivacyPolicy: {
    title: "Ändringar av denna integritetspolicy",
    list: [
      "Vi kan uppdatera denna integritetspolicy från tid till annan. Vi kommer att meddela dig om ändringar via e-post eller genom ett tydligt meddelande på vår webbplats. Vi rekommenderar att du regelbundet granskar denna policy för eventuella uppdateringar.",
    ]
  },
  contact: {
    title: "Kontaktinformation",
    text: "Om du har frågor angående denna integritetspolicy kan du kontakta oss via e-post:",
  },
},
};
